import * as yup from 'yup';

export const schema = yup.object({
  venueId: yup.number().required('This field is required'),
  testTakerAdmissionTimeMinutes: yup.number().min(0).max(99).nullable().default(null),
});

export type CreateAndLinkSpeakingSessionFormValues = yup.InferType<typeof schema>;
